const ReportSekolahStaEntity ={
    totalEnterpreanuer: null,
    prosentaseProfesional: null,
    prosentaseNextStudy: null,
    siswa: [],
    totalProfesional: null,
    prosentaseEnterpreanuer: null,
    totalNextStudy: null

}

export default ReportSekolahStaEntity;